import script from "./WithdrawRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./WithdrawRecords.vue?vue&type=script&setup=true&lang=js"

import "./WithdrawRecords.vue?vue&type=style&index=0&id=d85856f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d85856f0"]])

export default __exports__